<template>
    <div id="home" class="backing">
        <v-container fluid class="container" fill-height>
            <v-row>
                <v-col cols="12" md="4">
                    <div style="width:600px;margin: auto;">
                        ArtItem template. Need to figure out how to customize both slots on this template for each unique art piece.
                    </div>
                </v-col>
                <v-col cols="12" md="8">
                    <div>
                        <slot />
                    </div>
                </v-col>
            </v-row>

            <v-row justify="center">
            </v-row>
            <v-dialog v-model="dialog" persistent>
                <v-card>
                    <v-card-title>
                        dd
                    </v-card-title>
                    <v-card-text>
                        bladfjas;kfjas;df
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: 'Artitem',
        data () {
            return {
                dialog: false,
                alignment: 'center',
                dense: false,
                justify: 'center',
            }
        },
        methods: {
            LoadPaintingModal: function (args) {
              alert("ARGS: " + args);
              this.dialog = true;
          }
        },
        components: {
        }
    }
</script>

<style>
    .backing {
        background-color: #ccc;
    }
    .cards {
        min-height: 250px;
    }
    .container {
        max-width: 1200px;
        background-color: #fff;
    }
</style>
